export type UnknownItem = Record<string, unknown> & { id?: string | undefined };

export function toggleExcludedItem(items: unknown[], item: UnknownItem, excluded: boolean) {
  const id = itemId(item);
  const withoutItem = items.filter((current) => itemId(current) !== id);
  return excluded ? [...withoutItem, item] : withoutItem;
}

export function hasItemId(items: unknown[], id: string) {
  return items.some((item) => itemId(item) === id);
}

export function toRecords(value: unknown): UnknownItem[] {
  return Array.isArray(value)
    ? value.filter((item): item is UnknownItem => Boolean(item && typeof item === 'object'))
    : [];
}

export function itemId(item: unknown) {
  if (item && typeof item === 'object') {
    const id = (item as Record<string, unknown>)['id'];
    if (typeof id === 'string' && id.trim()) {
      return id;
    }
  }

  return itemLabel(item);
}

export function itemLabel(item: unknown) {
  if (item && typeof item === 'object') {
    const record = item as Record<string, unknown>;
    return stringValue(record['name']) || domainLabel(record) || stringValue(record['id']);
  }

  return String(item);
}

export function domainLabel(item: unknown) {
  if (item && typeof item === 'object') {
    const record = item as Record<string, unknown>;
    return stringValue(record['url']) || stringValue(record['domain']) || stringValue(record['id']);
  }

  return String(item);
}

export function companyName(item: UnknownItem) {
  return nestedName(item['company']) || '-';
}

export function nestedName(value: unknown) {
  if (value && typeof value === 'object') {
    return stringValue((value as Record<string, unknown>)['name']);
  }

  return '';
}

export function formatList(value: unknown) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item)).join(', ');
  }

  return stringValue(value);
}

export function stringValue(value: unknown) {
  return typeof value === 'string' ? value : '';
}
